import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from './base-control.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-checkbox-control',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxControlComponent),
            multi: true,
        },
    ],
    template: `
    <div class="app-pr1 app-pb1" [formGroup]="formGroup">
      <mat-checkbox
        [checked]="formControl.value"
        [disabled]="disabled"
        (change)="formControl.setValue($event.checked)"
        (blur)="onTouch()"
        >{{ label | translation:translationRequest }} {{ isRequired ? '*' : '' }}</mat-checkbox
        >
        @if (hintLabel) {
          <div class="checkbox-hint">{{ hintLabel | translation:translationRequest }}</div>
        }
        <div>
          @if (formControl.invalid && formControl.touched) {
            <mat-error
              class="checkbox-error"
              >{{ errorMessage | translation:translationRequest}}</mat-error
              >
            }
          </div>
        </div>
    `,
    styles: [
        `
      .checkbox-hint {
        font-size: 12px;
        margin-left: 44px;
      }
      .checkbox-error {
        margin-left: 44px;
      }
    `,
    ],
    standalone: false
})
export class CheckboxControlComponent
  extends BaseControlComponent
  implements ControlValueAccessor
{

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  disabled = false;
  onChange: any = () => {};
  onTouch: any = () => {};

  constructor() {
    super();
  }
  writeValue(obj: any): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
